import { FormSchema } from "../../../components/dynamicform/DynamicFormTypes";

const doiVersions = (window.env?.publication?.hbcdForm?.doiVersions ?? [])
    .slice()
    .sort((a: any, b: any) => `${a.value}`.localeCompare(`${b.value}`, undefined, { numeric: true }))
    .map((version: any) => ({
        label: `${version.value} <a href="${version.url}" target="_blank">Link to ${version.value} Release</a>`,
        value: `${version.value}`
    }))
export const hbcdForm: FormSchema = {
    title: "HBCD Information",
    fields: [
        {
            name: "hbcdDomains",
            type: "checkbox",
            label: "HBCD Domains",
            numColumns: 2,
            validationRules: {
                validate: {
                    atLeastOne: (v: string[]) => v.length > 0 || "Select at least one domain.",
                }
            },
            // Populated at runtime from GET /api/publications/domains, see setDomainOptions in publicationSlice.tsx
            options: []
        },
        {
            name: "hbcdReleaseVersion",
            type: "radio",
            label: "Please select which release version you used for your publication?",
            defaultValue: doiVersions[0]?.value || "1.0 (DOI Link)",
            options: [
                ...(doiVersions || []),
                { label: "Other: ", value: "", dynamic: true },
            ]
        }
    ]
};